export const className = {
  readMore: `about_read_more`,
  EnPTitle: `about_EnP_title`,
  EnPName: `about_EnP_name`,
}
